import { render, staticRenderFns } from "./ChatArea.vue?vue&type=template&id=e7a22cf4&scoped=true&"
import script from "./ChatArea.vue?vue&type=script&lang=js&"
export * from "./ChatArea.vue?vue&type=script&lang=js&"
import style0 from "./ChatArea.vue?vue&type=style&index=0&id=e7a22cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a22cf4",
  null
  
)

export default component.exports